import * as React from 'react';
import { faTrophy } from '@fortawesome/pro-solid-svg-icons';
import { Layout } from 'components/layout';
import { SEO } from 'components/SEO';
import { Title } from 'components/Title';
import { PrimaryLink as Link } from 'components/links';

import 'reflect-metadata';
import { useFeatureFlags } from 'lib/useFlags';
import { MessageBox } from 'components/MessageBox';
import { NewsletterForm } from 'components/Newsletter';
import Image from 'next/image';
import RaffleFlyer from 'assets/images/raffle-flyer.png';

const RafflePage: React.FC = () => {
  const { flags } = useFeatureFlags();
  return (
    <Layout>
      <SEO title='Raffle' />

      <main className='my-12 flex-grow space-y-6 lg:my-16'>
        <div className='container max-w-4xl '>
          <Title className='mb-4'>World Fair Trade Day Raffle</Title>
        </div>

        {flags.EVENT_IS_ENDED && (
          <section>
            <MessageBox icon={faTrophy} title='Event Ended'>
              {/* <h3 className='text-center text-3xl font-bold '> */}
              Thanks to all that participated! We'll be drawing the raffles and
              contacting the winners shortly.
              {/* </h3> */}
            </MessageBox>
          </section>
        )}
        <section className='text-lg leading-relaxed text-stone-600'>
          <div className='container my-12 max-w-4xl '>
            <p>
              Thanks to the generous support of our sponsors and donors, we are
              thrilled to offer several raffle prizes to celebrate World Fair
              Trade Day!
            </p>

            <div className='grid gap-6'>
              <div className='mt-8 flex flex-col gap-6 sm:flex-row'>
                <Link href='https://auctria.events/worldfairtradeday'>
                  <Image
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    src={RaffleFlyer}
                    alt=''
                    width={840}
                    height={1087}
                    loading='lazy'
                  />
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className='bg-green-700 px-4 py-12' id='newsletter'>
          <div className='container mx-auto max-w-7xl text-xl text-teal-500'>
            <NewsletterForm
              headline='Get Notified'
              subHeading="Sign up for our newsletter to stay up to date on next year's World Fair Trade day event and other great CFT news."
            />
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default RafflePage;
